import { Injectable, inject } from '@angular/core';
import { AssignmentProcessService, ProcessFailurePolicyResponse } from '@6grain/masofa-monolith-api-client/common';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

/** Body and response of PUT /assignments/processes/{processKey}/failure-policy. */
export interface ProcessFailurePolicyDto {
  interruptionPolicy: string;
  resumeAttemptLimit: number;
  pauseAfterConsecutiveFailures: number;
}

/** Process failure policy. */
@Injectable({ providedIn: 'root' })
export class ProcessFailurePolicyService {
  private readonly api = inject(AssignmentProcessService);

  save(processKey: string, body: ProcessFailurePolicyDto): Observable<ProcessFailurePolicyDto> {
    return this.api.assignmentsProcessesProcessKeyFailurePolicyPut(processKey, body).pipe(map(normalizePolicy));
  }
}

function normalizePolicy(row: ProcessFailurePolicyResponse): ProcessFailurePolicyDto {
  return {
    interruptionPolicy: row.interruptionPolicy ?? '',
    resumeAttemptLimit: row.resumeAttemptLimit ?? 0,
    pauseAfterConsecutiveFailures: row.pauseAfterConsecutiveFailures ?? 0,
  };
}
